import './Expandable.scss';
export default function Expandable({ isExpanded, className, children }) {
  return (
    <div
      className={`expandables ${className}
        ${isExpanded ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}
      `}
    >
      <div className="min-h-0">{children}</div>
    </div>
  );
}
